module.exports = __webpack_public_path__ + "img/file-heart-01.d0336a60.svg";